import { Link } from "react-router";
import { APP_VERSION } from "@/app-version";
import { cn } from "@/lib/utils";

const swoosh = "/branding/apps-swoosh.png";

export function Brand({ compact = false, showVersion = true, className }: { compact?: boolean; showVersion?: boolean; className?: string }) {
  return (
    <Link to="/apps" className={cn("inline-flex items-center gap-3", className)} aria-label="Cheesy Apps home">
      <span className="flex h-11 w-[76px] items-center justify-center rounded-lg bg-white px-2 shadow-sm">
        <img src={swoosh} alt="" className="max-h-8 w-auto object-contain" />
      </span>
      {!compact && (
        <span className="leading-none">
          <strong className="font-display text-xl tracking-tight">Cheesy Apps</strong>
          {showVersion && <span className="mt-1 block text-[10px] font-bold uppercase tracking-[0.19em] text-muted-foreground">Version {APP_VERSION}</span>}
        </span>
      )}
    </Link>
  );
}
